export default __webpack_public_path__ + "static/media/lightbulb.be03aefe.svg";